module.exports = __webpack_public_path__ + "assets/img/steam_active.5fc91778.png";